import { MutationType } from '@tencent/slide-sdk-pb-model';
import { BaseMutation } from '../base/base-mutation';
import type { PresentationDataModel } from '../../model/presentation-data-model';
import type { MaybeError } from '../base/base-mutation';
import type { IValidSetSlideSizeMutationData } from '../base/valid-mutation-data';

export class SetSlideSizeMutation extends BaseMutation<PresentationDataModel, IValidSetSlideSizeMutationData> {
    public readonly type: MutationType = MutationType.SetSlideSize;

    public apply(presentation: PresentationDataModel) {
        presentation.store.patchData({ sldSz: this.data.size });
    }

    public invert(presentation: PresentationDataModel): [IValidSetSlideSizeMutationData] {
        return [
            {
                type: MutationType.SetSlideSize,
                size: { ...presentation.getOwnedData().sldSz },
            },
        ];
    }

    public check(): MaybeError {
        return;
    }
}
